import { Button, ModalProps } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import { Dialog } from './components/styles';

/** Reuse the authorization flow in either its existing dialog or the Agent sidebar. */
export default function AuthShopSurface({
  presentation,
  onCloseSidebar,
  ...props
}: ModalProps & {
  presentation?: 'sidebar' | 'business';
  children?: ReactNode;
  onCloseSidebar?: () => void;
}) {
  if (presentation !== 'sidebar') return <Dialog {...props} />;
  if (!props.visible) return null;
  return (
    <section className="fett-agent-store-auth">
      <header className="fett-agent-store-auth-header">
        {props.title}
        {props.closable && (
          <Button
            type="text"
            aria-label="Close"
            icon={<CloseOutlined />}
            onClick={onCloseSidebar}
          />
        )}
      </header>
      <div style={{ position: 'relative', padding: '24px', ...props.bodyStyle }}>
        {props.children}
      </div>
    </section>
  );
}
